import React, { useState, useEffect } from 'react';
import { IAction, ActionTypes, IPolicyDefaults, Conjuction, IActionData, RuleElements } from '@app/models';
import { Operator, DenyAccess, AllowedMethods, RequiredMethods, SessionLifetimes, AddElement } from '../components';
import { PasslySelect } from '@app/components';
import { createActionTypes } from '../methods';

import { useDispatch } from 'react-redux';
import { addMainRuleElseAction, removeElseAction, updateElseAction } from '@app/store/actions';
import { TrustDevices } from './actions/trustDevices.component';
import { IconButton } from '@material-ui/core';
import { DeleteOutline } from '@material-ui/icons';

interface IProps {
    index: number;
    isLast: boolean;
    elseAction: IAction;
    defaults: IPolicyDefaults;
    patchData: IActionData | null;
    validation?: Function;
}

export const ElseAction = (props: IProps) => {
    const { index, isLast, elseAction, defaults, patchData, validation } = props;
    const dispatch = useDispatch();
    const [reset, setReset] = useState<any>(0);

    const [selectedElseAction, setSelectedElseAction] = useState<ActionTypes | ''>('');
    const [statementText, setStatementText] = useState<string>('');
    const [isValid, setIsValid] = useState<boolean>(false);

    const handleElseActionSelect = (event: React.ChangeEvent<{ value: unknown }>) => {
        setSelectedElseAction(event.target.value as ActionTypes);
        setIsValid(false);
        setReset(reset + 1);
    };

    const getData = (valid: boolean, received: any) => {
        setIsValid(valid);

        if (valid && received !== null && selectedElseAction !== '') {
            dispatch(updateElseAction(elseAction.id, received, selectedElseAction));
        }
    };

    useEffect(() => {
        index === 0 ? setStatementText(Conjuction.else) : setStatementText(Conjuction.and);
    }, [index]);

    useEffect(() => {
        if (patchData !== null) {
            setSelectedElseAction(patchData.Type);
        }
    }, [patchData]);

    const getIcon = (item: any) => {
        return <div className='condition__select-icon'>{item.icon}</div>;
    };

    useEffect(() => {
        if (!validation) {
            return;
        }

        isValid ? validation(true, RuleElements.elseAction) : validation(false, RuleElements.elseAction);
    }, [isValid]);

    return (
        <div className='action condition'>
            <div className='condition__aside'>
                <div className='condition__statement'>
                    <Operator text={statementText} />
                </div>
                {isLast && (
                    <div className='condition__add'>
                        <AddElement disabled={!isValid} onClick={() => dispatch(addMainRuleElseAction(null))} />
                    </div>
                )}
            </div>

            <div className='condition__container'>
                <div className='condition__selection'>
                    <PasslySelect
                        id='elseActionSelect'
                        label={'AUTH_POLICY_ACTION_LABEL'}
                        value={selectedElseAction}
                        onChange={handleElseActionSelect}
                        options={createActionTypes()}
                        icon={getIcon}
                    />
                </div>
                <div className='condition__criteria'>
                    {selectedElseAction === ActionTypes.denyAccess && <DenyAccess checkValidation={getData} />}
                    {selectedElseAction === ActionTypes.allowedMethods && (
                        <AllowedMethods
                            checkValidation={getData}
                            reset={reset}
                            methods={defaults.FirstFactorMethods}
                            patchData={patchData?.Configuration}
                        />
                    )}
                    {selectedElseAction === ActionTypes.requiredMethods && (
                        <RequiredMethods
                            checkValidation={getData}
                            reset={reset}
                            methods={defaults.SecondFactorMethods}
                            patchData={patchData?.Configuration}
                        />
                    )}
                    {selectedElseAction === ActionTypes.sessionLifetime && (
                        <SessionLifetimes checkValidation={getData} session={defaults.Session} patchData={patchData?.Configuration} />
                    )}
                    {selectedElseAction === ActionTypes.trustedDevice && (
                        <TrustDevices checkValidation={getData} patchData={patchData?.Configuration} />
                    )}
                </div>
                {statementText !== Conjuction.else ? (
                    <div className='condition__delete'>
                        <IconButton size='small' onClick={() => dispatch(removeElseAction(elseAction.id))}>
                            <DeleteOutline />
                        </IconButton>
                    </div>
                ) : null}
            </div>
        </div>
    );
};
